import { __assign } from "tslib";
import { FontIcon } from '@fluentui/react';
import { Caption1, Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger, mergeClasses, useIsOverflowItemVisible, useOverflowMenu, } from '@fluentui/react-components';
import { useIsDarkMode } from '@office-start/theming-service';
import { getFileTypeIconProps } from '@uifabric/file-type-icons';
import React from 'react';
import { useCardStyles } from './views/RecommendedCardControl.styles';
var MeetingInsightsOverflowMenuItem = function (_a) {
    var id = _a.id, meetingObject = _a.meetingObject, onMeetingInsightsDocClick = _a.onMeetingInsightsDocClick;
    var isVisible = useIsOverflowItemVisible(id);
    var cardClasses = useCardStyles();
    if (isVisible) {
        return null;
    }
    return (React.createElement(MenuItem, { className: cardClasses.meetingInsightsMenuItem, onClick: function (event) {
            event.stopPropagation();
            onMeetingInsightsDocClick &&
                onMeetingInsightsDocClick(meetingObject, parseInt(id), parseInt(id), 'Recommended', event);
        } },
        React.createElement("div", { className: cardClasses.meetingInsightsOverflowItem },
            React.createElement(FontIcon, __assign({ className: cardClasses.meetingInsightsIcon }, getFileTypeIconProps({
                size: 16,
                extension: meetingObject.extension,
                imageFileType: 'svg',
            }))),
            React.createElement(Caption1, { className: mergeClasses(cardClasses.text, cardClasses.truncateText) }, meetingObject.title))));
};
export var MeetingInsightsOverflowMenu = function (_a) {
    var meetingObjects = _a.meetingObjects, onMeetingInsightsDocClick = _a.onMeetingInsightsDocClick;
    var _b = useOverflowMenu(), ref = _b.ref, overflowCount = _b.overflowCount, isOverflowing = _b.isOverflowing;
    var cardClasses = useCardStyles();
    var isDarkMode = useIsDarkMode();
    if (!isOverflowing) {
        return null;
    }
    return (React.createElement(Menu, null,
        React.createElement(MenuTrigger, { disableButtonEnhancement: true },
            React.createElement(MenuButton, { className: mergeClasses(cardClasses.insightsOverflowButton, isDarkMode
                    ? cardClasses.insightsOverflowButtonDarkMode
                    : cardClasses.insightsOverflowButtonLightMode), onClick: function (event) {
                    event.stopPropagation();
                }, ref: ref },
                "+",
                overflowCount)),
        React.createElement(MenuPopover, null,
            React.createElement(MenuList, null, meetingObjects.map(function (meetingObject, index) {
                return (React.createElement(MeetingInsightsOverflowMenuItem, { key: index, meetingObject: meetingObject, id: index, onMeetingInsightsDocClick: onMeetingInsightsDocClick }));
            })))));
};
//# sourceMappingURL=MeetingInsightsOverflowMenu.js.map